// French for NetworkPage.tsx (docs/R5-NETWORK-DESIGN.md). Keys already carried by
// `i18n/common.fr.ts`, `NetworkZone.fr.ts` and `FlowMatrix.fr.ts` (this page imports both
// components, so their catalogues are registered) are not repeated here.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Who works with whom': 'Qui travaille avec qui',
  'payers': 'financeurs',
  'providers': 'prestataires',
  'links': 'liens',
  'latest year': 'dernière année',
  'Which organisations work with which, and how many people from which institution are placed where.':
    'Quelles organisations travaillent avec lesquelles, et combien de personnes de quelle institution sont placées où.',
  'Proposed links in Review': 'Liens proposés en révision',

  'Matrix': 'Matrice',
  'Canton': 'Canton',
  'Sub-sector': 'Sous-secteur',
  'held only': 'tenus seulement',
  'by regime': 'par régime',
  'Clear filters': 'Effacer les filtres',
  'Find an organisation to focus…': 'Chercher une organisation à cibler…',
  'nothing to filter by yet': 'rien à filtrer pour l’instant',
  'Sort by this column': 'Trier par cette colonne',

  'Payers': 'Financeurs',
  '{b} bodies · {r} regimes · {o} residual': '{b} organismes · {r} régimes · {o} résiduels',
  '{n} of {m} providers give a count': '{n} prestataires sur {m} donnent un nombre',
  'of {m} payers · the coverage bars’ denominator': 'sur {m} financeurs · le dénominateur des barres de couverture',
  'no payer holds a channel volume yet': 'aucun financeur ne tient encore de volume de canal',
  'channel.measure_participants — people who received at least one insertion or training measure in the year, read on the payer body itself':
    'channel.measure_participants — personnes ayant reçu au moins une mesure d’insertion ou de formation dans l’année, lue sur l’organisme financeur lui-même',
  'no payer holds channel.measure_participants yet — the coverage column appears once a run reads one':
    'aucun financeur ne tient encore channel.measure_participants — la colonne de couverture apparaît dès qu’une recherche en lit une',
  'payer, referrer and funder counterparts': 'contreparties financeur, prescripteur et bailleur',
  'Providers': 'Prestataires',
  'of {total} organisations on the record': 'sur {total} organisations enregistrées',
  'organisations naming a link': 'organisations nommant un lien',
  'Links held': 'Liens tenus',
  '{p} proposed': '{p} proposés',
  'nothing waiting in review': 'rien n’attend en révision',
  'People accounted': 'Personnes attribuées',
  'a named payer accounts for them · {n} of {m} providers give a count': 'un financeur nommé en répond · {n} prestataires sur {m} donnent un nombre',
  'participants a named payer accounts for': 'participants dont un financeur nommé répond',
  'Σ over payers of the people their named providers account for — computed, carries no mark':
    'Σ sur les financeurs des personnes dont leurs prestataires nommés répondent — calculée, sans marque',
  'Channel volumes': 'Volumes des canaux',
  'of {m} payers hold a channel.measure_participants reading — the coverage bars’ denominator':
    'sur {m} financeurs tiennent une lecture channel.measure_participants — le dénominateur des barres de couverture',
  'no payer holds channel.measure_participants yet — the coverage bars have no denominator':
    'aucun financeur ne tient encore channel.measure_participants — les barres de couverture n’ont pas de dénominateur',

  'Focus': 'Cible',
  'Neighbourhood': 'Voisinage',
  'this organisation and its links only; a square is a payer body; dashed is proposed, dotted is estimated; the figure is the source’s own':
    'cette organisation et ses liens seulement ; un carré est un organisme financeur ; le pointillé large est proposé, le pointillé fin estimé ; le chiffre est celui de la source',

  'The network could not be read: {error}': 'Le réseau n’a pas pu être lu : {error}',
  'No link matches these filters. Clear one to widen the slice.': 'Aucun lien ne correspond à ces filtres. En effacer un pour élargir la tranche.',
  'No link is on the record yet. A research run files the payers, mandants and federations an organisation’s pages name; an operator declares one from an organisation’s Network zone.':
    'Aucun lien n’est encore enregistré. Une recherche enregistre les financeurs, mandants et faîtières que les pages d’une organisation nomment ; un opérateur en déclare un depuis la zone Réseau d’une organisation.',

  'who pays for whom: a bar is a length on a zero baseline; the dotted rest is the channel’s volume nobody has accounted for':
    'qui paie pour qui : une barre est une longueur depuis zéro ; le reste pointillé est le volume du canal dont personne ne répond',
  'Σ within': 'Σ en',
  'each Σ within the payer’s own latest year': 'chaque Σ dans la dernière année propre du financeur',
  'Payer': 'Financeur',
  'Coverage of the channel’s volume': 'Couverture du volume du canal',
  'Places': 'Places',
  'CHF': 'CHF',
  '{n} bodies folded': '{n} organismes regroupés',
  'residual line': 'ligne résiduelle',
  '{n} give a count': '{n} donnent un nombre',
  'of': 'de',
  'none of {m} accounted': 'aucune des {m} attribuée',
  'volume not collected': 'volume non relevé',
  'the channel counts {m} people in a measure ({when}); no provider gives a count yet':
    'le canal compte {m} personnes en mesure ({when}) ; aucun prestataire ne donne encore de nombre',
  'this body holds no channel.measure_participants cell — the bar has no denominator until a run reads one':
    'cet organisme ne tient pas de cellule channel.measure_participants — la barre n’a pas de dénominateur tant qu’une recherche n’en lit pas',
  '{n} of {m} payers hold a channel volume': '{n} financeurs sur {m} tiennent un volume de canal',
  'a percentage is never summed across organisations; places and CHF are Σ within one year':
    'un pourcentage n’est jamais sommé entre organisations ; places et CHF sont des Σ dans une seule année',
  'Other counterparts': 'Autres contreparties',
  'umbrellas, partners, accreditors, vendors, consultants, auditors — relations without a flow of people or money':
    'faîtières, partenaires, autorités de reconnaissance, fournisseurs, conseils, organes de révision — des relations sans flux de personnes ni d’argent',

  'one row per organisation naming a link; the mix is a 100 % stacked bar of its participants (or revenue) by payer, largest first, the dotted rest unattributed':
    'une ligne par organisation nommant un lien ; le mix est une barre empilée à 100 % de ses participants (ou produits) par financeur, le plus grand d’abord, le reste pointillé non attribué',
  'Payers named': 'Financeurs nommés',
  'Clients per year': 'Bénéficiaires par an',
  'no mix on the record': 'aucun mix enregistré',
  '{n} amounts read, no same-year revenue to divide by': '{n} montants lus, aucun produit de la même année pour diviser',
  'of participants': 'des participants',
  '{name}: {basis}, {year} — {n} payers named, {a} % attributed, the dotted rest unattributed':
    '{name} : {basis}, {year} — {n} financeurs nommés, {a} % attribués, le reste pointillé non attribué',
  'the mix does not sum to 100': 'le mix ne totalise pas 100',
  'as of': 'au',

  'providers down, payers across; a cell’s ink is the share of the provider’s participants the payer accounts for, a figure is a count or an amount, ▪ a relation with no figure, ◇ a proposal':
    'prestataires en lignes, financeurs en colonnes ; l’encre d’une cellule est la part des participants du prestataire dont le financeur répond, un chiffre est un nombre ou un montant, ▪ une relation sans chiffre, ◇ une proposition',
  "realised; the budget row is on the organisation's page": 'comptes ; la ligne du budget est sur la page de l’organisation',
}, 'NetworkPage');
